import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import styles from './FilterButton.module.css'

const FilterButton = ({ text, onClick, selected, badge }: { text: string, onClick: any, selected: boolean, badge: any }) => {
    return (
        <ButtonBase className={`${styles.filter_btn} ${selected ? styles.filter_btn_selected: ""}`} onClick={onClick}>
            <Typography variant='caloriesText'>{text}</Typography>
            <Typography variant='caloriesText'>{badge > 0 ? `(` + badge + `)` : ''}</Typography>
        </ButtonBase>
    )
};

export default FilterButton;